<app-navbar></app-navbar>
      <!-- Percentile and Charts Section - Coming next -->
      <div class="dashboard-container">
        <div class="container-fluid">
          <div *ngIf="loadingDashboard" class="text-center py-4">
            <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
            <p class="mt-2 text-muted">Loading dashboard...</p>
          </div>

          <ng-container *ngIf="!loadingDashboard">
          <!-- Header -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="dashboard-header">
                <h2>Performance Dashboard</h2>
                <p class="user-info">User ID: {{ userId || userPerformanceData?.userId }}</p>
                <p class="user-info">Session ID: {{ sessionId || userPerformanceData?.sessionId }}</p>
              </div>
            </div>
          </div>
      
          <!-- Qualified Roles Section -->
          <div class="row">
            <div class="col-12">
              <app-qualified-roles 
                [qualifiedRolesData]="userPerformanceData?.qualified_roles"
                [versatilityData]="userPerformanceData?.versatility">
              </app-qualified-roles>
            </div>
          </div>
      
          <!-- Charts Section -->
          <div class="row mt-4">
            <div class="col-lg-6">
              <app-skills-radar-chart 
                [rawScores]="userPerformanceData?.raw_scores"
                [percentileScores]="userPerformanceData?.percentile_info?.trait_percentiles">
              </app-skills-radar-chart>
            </div>
            <div class="col-lg-6">
              <app-percentile-chart 
                [percentileInfo]="userPerformanceData?.percentile_info">
              </app-percentile-chart>
            </div>
          </div>
          </ng-container>
        </div>
      </div>
<app-footer></app-footer>
